module.exports = __webpack_public_path__ + "static/media/master.55c42d54.svg";